import { useCallback, useMemo } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { uaParser } from '@encarpkg/shared';
import { changeValue, changeTerms } from 'app/store/modules/buyInquiry';
import { numberWithHyphen } from 'app/libs/number';
import * as api from 'app/api';

export default function useInquiry() {
	const { isPc } = uaParser();
	const { base, profile } = useSelector((state) => state.cars, shallowEqual);
	const { textInquiry, phoneNumber, inquiryItems, selectInquiry, selectCategory, termsAgreement, isExchange } = useSelector(
		(state) => state.buyInquiry,
		shallowEqual,
	);
	const { user, userInfo } = useSelector((state) => state.auth, shallowEqual);
	const { carType, manufacturerCd, modelGroupCd, modelCd, yearsCd, milage, formCd, formDetailCd, capacityCd } = useSelector(
		(state) => state.carInfoSelect,
		shallowEqual,
	);
	const isContactableTime = useMemo(() => {
		if (base.contact?.userType === 'CLIENT') {
			if (!profile.userProfile?.contactableTime?.startTimeType) return true;
			if (!profile.userProfile?.contactableTime?.canContact) return false;
		}
		return true;
	}, [base.contact?.userType, profile.userProfile?.contactableTime?.canContact, profile.userProfile?.contactableTime?.startTimeType]);

	const displayContactNumber = !isContactableTime ? '050-****-****' : numberWithHyphen(base.contact?.no ?? '');
	const dispatch = useDispatch();

	const changeComm = useCallback((payload) => dispatch(changeValue(payload)), [dispatch]);
	const changeTermsInfo = useCallback((payload) => dispatch(changeTerms(payload)), [dispatch]);
	const checkPhoneCertify = useCallback((phoneNum) => api.getPhoneCertified(phoneNum), []);
	const postBuyInquiryInfo = useCallback(
		(carId, phone) => {
			const defaultText = '안녕하세요. 차량에 관심있습니다.';
			const selectSimple = inquiryItems.filter((item) => item.id === selectInquiry)[0]?.body;
			let swapCar = null;
			let swapTruck = null;
			if (isExchange === 'exchangeYes' && carType === 'TRUCK') {
				swapTruck = {
					formcd: formCd,
					formdtlcd: formDetailCd,
					capacd: capacityCd,
					mnfccd: manufacturerCd,
					modelcd: modelCd,
					yr: yearsCd,
					mlg: milage,
				};
			}
			if (isExchange === 'exchangeYes' && carType !== 'TRUCK') {
				swapCar = {
					mnfccd: manufacturerCd,
					modelgroupcd: modelGroupCd,
					modelcd: modelCd,
					yr: yearsCd,
					mlg: milage,
				};
			}

			const data = {
				phoneNumber: phone,
				userId: user?.id || null,
				carId,
				email: userInfo?.email || null,
				channel: isPc ? 'WWW_WEB' : 'MOBILE_WEB',
				memo: textInquiry || selectSimple || defaultText,
				swapCar,
				swapTruck,
			};
			return api.postBuyInquiry(data);
		},
		[
			capacityCd,
			carType,
			formCd,
			formDetailCd,
			inquiryItems,
			isExchange,
			manufacturerCd,
			milage,
			modelCd,
			modelGroupCd,
			selectInquiry,
			textInquiry,
			user,
			userInfo,
			yearsCd,
			isPc,
		],
	);

	return {
		textInquiry,
		phoneNumber,
		inquiryItems,
		selectInquiry,
		selectCategory,
		isExchange,
		isContactableTime,
		displayContactNumber,
		termsAgreement,
		changeComm,
		changeTermsInfo,
		checkPhoneCertify,
		postBuyInquiryInfo,
	};
}
